module.exports = __webpack_public_path__ + "img/zubehoer_aktivierungsvorrichtung.c160d34c.jpg";